export enum AutocompleteFieldsConstants {
  REFERENCE = 'reference',
  ENUMBER = 'enumber'
}
